import { IUser, ResourceAutoCompleteViewModelType } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { getDisplayName } from '../../../../../models/NameUtils';
import { asModalComponent } from '../../../Modal';
import {
	ISimpleAutoCompleteSearchFieldEvent,
	ISimpleAutoCompleteSearchFieldItemSelectionEvent,
	SimpleAutoCompleteSearchField,
} from '../../../autocomplete/SimpleAutoCompleteSearchField';
import { styleSheet } from './styles';

interface IProps {
	onSelectionMade?(selection: IUser): void;
}

const SearchEmployeeModalComponent = ({ onSelectionMade }: IProps) => {
	const [selectedEmployee, setSelectedEmployee] = React.useState<IUser | null>(null);

	const onSearchFieldBlur = (e: ISimpleAutoCompleteSearchFieldEvent<React.FocusEvent<HTMLInputElement>>) => {
		if (!selectedEmployee && e.target) {
			e.target.clearInput();
		}
	};

	const onSearchFieldKeyDown = (e: ISimpleAutoCompleteSearchFieldEvent<React.KeyboardEvent<HTMLInputElement>>) => {
		if (e.sourceEvent && e.sourceEvent.key !== 'Enter') {
			clearSelectedUser();
		}
	};

	const onUserSelected = (
		e: ISimpleAutoCompleteSearchFieldItemSelectionEvent<string | import('@ViewModels').IEntity | IUser>
	) => {
		const selection = e.selection;
		// Type guard: ensure we have an IUser object
		if (typeof selection === 'string' || !('id' in selection)) {
			return;
		}

		if (e.target) {
			e.target.setSearchQuery(getDisplayName(selection as IUser));
		}

		if (onSelectionMade) {
			onSelectionMade(selection as IUser);
		}
		setSelectedEmployee(selection as IUser);
	};
	const clearSelectedUser = () => setSelectedEmployee(null);
	return (
		<article>
			<h3 className={css(styleSheet.title)}>Employee Search</h3>
			<SimpleAutoCompleteSearchField
				onBlur={onSearchFieldBlur}
				onClear={clearSelectedUser}
				onItemSelected={onUserSelected}
				onKeyDown={onSearchFieldKeyDown}
				pageSize={5}
				placeholder='Search employees'
				resultsLimit={5}
				type={ResourceAutoCompleteViewModelType.User}
			/>
		</article>
	);
};

export const SearchEmployeeModal = asModalComponent(SearchEmployeeModalComponent, {
	className: 'search-employee-modal',
	useDefaultHeader: true,
});
